<template>
  <v-row align="center">
    <v-col cols="1">
      <v-checkbox
        dense
        class="ma-0 pa-0"
        v-model="innerVal"
      ></v-checkbox>
    </v-col>
    <v-col cols="10" class="mb-5">
      <span
        :class="[
          'clickable', 
          'grey--text',
          { 'primary--text': innerVal }
        ]"
        @click="innerVal = !innerVal"
      >
        {{ label }}
      </span>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    name: 'NotesLabItem',

    props: {
      value: { type: Boolean, default: false },
      label: { type: String, default: '' }
    },

    data(){
      return {
        innerVal: this.value
      }
    },

    watch: {
      innerVal(val) {
        this.$emit('input', val)
        this.$emit('check', val)
      },

      tests(val) {
        this.innerVal = val.includes(this.label)
      },      
    },

    computed: {
      tests() { return this.$store.getters['request/tests'] },
    },

    mounted() {
      setTimeout(() => {
        if(this.tests != null) {
          this.innerVal = this.tests.includes(this.label);
        }
      }, 5000)
    }
  }
</script>

<style lang="scss" scoped>
</style>